/* global gtag */
import React, { useEffect, useCallback, useRef, useState } from "react";
import {
  Container,
  LoadingText,
  TextContainer,
  SlowSpinner,
  Overlay,
  ErrorBox,
  ErrorIcon,
  ButtonReturn,
  ButtonsContainer,
  ButtonSupport,
} from "./styles";
import api from "../../services/client/api";
import ls from "../../services/localStorage/index";
import { useHistory } from "react-router-dom";
import {
  faQuestionCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cookie from "../../services/cookie/index";
function BiometricResult() {
  const history = useHistory();
  const attemptRef = useRef(0); // contador de tentativas
  const intervalRef = useRef(null); // referência do setInterval
  const [alertResponse, setAlertResponse] = useState("");
  const [response, setResponse] = useState(null);
  const siteUrl = "https://www.cedap.com.br/duvidas"; // URL do site que será aberto

  const handleClick = () => {
    window.open(siteUrl, "_blank"); // Abre o site em uma nova aba
  };

  const SearchResult = useCallback(
    async (sessionVeriff, userDataToken) => {
      try {
        const response = await api()
          .user()
          .getBiometricResult(sessionVeriff, userDataToken);
        setResponse(response); // Armazenar o response no estado
        if (response.output.user.username !== "") {
          clearInterval(intervalRef.current); // para o loop se aprovado
          await cookie().set("token", response.output.token, 30 / 1440);
          await cookie().set("role", response.output.user.role, 30 / 1440);
          await cookie().set(
            "username",
            response.output.user.username,
            30 / 1440,
          );
          await cookie().set("name", response.output.user.name, 30 / 1440);
          // ✅ GA4: Login Success
          gtag("event", "login_success", {
            event_category: "auth",
            value: 200,
          });
          history.replace({
            pathname: "/",
          });
        } else if (response.status === 422) {
          switch (response.message) {
            case "recusado":
            case "revisao":
            case "recoleta":
              // A biometria foi recusada, dados fornecidos não conferem
              clearInterval(intervalRef.current);
              setAlertResponse("A biometria não pôde ser validada.");
              break;

            case "expirado":
            case "abandono":
              // Sessão expirou
              clearInterval(intervalRef.current);
              alert("Sua sessão expirou, realize o processo novamente.");
              history.replace({
                pathname: "/cpf-user-check",
                state: {
                  cpf: response.data.data,
                },
              });
              ls().del("userDataToken");
              ls().del("sessionTokenVeriff");

              break;
            default:
              // Qualquer outro erro
              clearInterval(intervalRef.current);
              setAlertResponse("A biometria não pôde ser validada.");
              break;
          }
        }
      } catch (error) {
        attemptRef.current += 1;
        if (attemptRef.current >= 3) {
          // Verificação após a terceira tentativa
          const userDataToken = ls().get("userDataToken");
          const sessionVeriff = ls().get("sessionTokenVeriff");
          if (!userDataToken || !sessionVeriff) {
            clearInterval(intervalRef.current);
            setAlertResponse("A biometria não pôde ser validada.");
          }
        }
        if (attemptRef.current >= 7) {
          clearInterval(intervalRef.current);
          setAlertResponse("A biometria não pôde ser validada.");
        }
      }
    },
    [history],
  );

  useEffect(() => {
    const userDataToken = ls().get("userDataToken");
    const sessionVeriff = ls().get("sessionTokenVeriff");
    // Faz a chamada inicial
    SearchResult(sessionVeriff, userDataToken);

    // Define o loop a cada 5 segundos
    intervalRef.current = setInterval(() => {
      if (attemptRef.current < 7) {
        SearchResult(sessionVeriff, userDataToken);
      }
    }, 5000);

    // Cleanup para garantir que o setInterval seja limpo
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [history, SearchResult]);
  const handleTryAgain = () => {
    history.replace({
      pathname: "/cpf-user-check",
      state: {
        cpf: response.data.data,
      },
    });
    ls().del("userDataToken");
    ls().del("sessionTokenVeriff");
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (alertResponse !== "") {
        ls().del("userDataToken");
        ls().del("sessionTokenVeriff");
        history.replace({ pathname: "/cpf-user-check" });
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [alertResponse, history]);

  return (
    <Container>
      {alertResponse ? (
        <Overlay>
          <ErrorBox>
            <ErrorIcon icon={faTimesCircle} />
            <LoadingText>{alertResponse}</LoadingText>
            <h3>
              Tente novamente. <br /> Se algo não funcionar como esperado, entre
              em contato com a equipe de suporte.
            </h3>

            <ButtonsContainer>
              <ButtonReturn onClick={handleTryAgain}>
                Tentar novamente
              </ButtonReturn>

              <ButtonSupport
                onClick={handleClick}
                target="_blank"
                rel="noopener noreferrer"
              >
                Duvidas{" "}
                <FontAwesomeIcon
                  style={{ marginLeft: 5, fontSize: "18px" }}
                  icon={faQuestionCircle}
                />
              </ButtonSupport>
            </ButtonsContainer>
          </ErrorBox>
        </Overlay>
      ) : (
        // Exibe o loader enquanto não houver erro
        <>
          <SlowSpinner
            style={{ width: "3rem", height: "3rem", marginBottom: "20px" }}
            color="primary"
          />
          <LoadingText>
            Aguardando a verificação das suas informações...
          </LoadingText>
          <TextContainer>
            Esse processo pode levar alguns segundos. Por favor, aguarde.
          </TextContainer>
        </>
      )}
    </Container>
  );
}

export default BiometricResult;
